<template>
  <div>
    <div class="vx-row min-h-screen">
      <div class="vx-col w-full">
        <header-public></header-public>
      </div>
      <div class="vx-col w-full legal-text">
        <div class="container w-full max-w-5xl mx-auto px-3 py-12">
          <div class="vx-row">
            <div class="vx-col w-full">
              <a href="/" class="link-back" >{{ $t('GoHome') }}</a>
              <h1>{{ $t('avisoLegal.AvisoLegal') }}</h1>
              <h2>{{ $t('avisoLegal.Title1') }}</h2>
              <p>{{ $t('avisoLegal.Text1') }}</p>
              <p>{{ $t('avisoLegal.Text1_1') }} <a href="https://www.barify.es" target="_blank" >www.barify.es</a> y <a href="https://www.barify.bar" target="_blank" >www.barify.bar</a>.{{ $t('avisoLegal.Text1_2') }}</p>
              <p>{{ $t('avisoLegal.Text1_3') }}</p>
              <h2>{{ $t('avisoLegal.Title2') }}</h2>
              <p>{{ $t('avisoLegal.Text2_1') }} <a href="https://www.barify.es" target="_blank" >www.barify.es</a> y <a href="https://www.barify.bar" target="_blank" >www.barify.bar</a>.</p>
              <p><strong>{{ $t('Denomiacion') }}</strong>: SERVIPYME NEWTECH, S.L.<br />
              <strong>{{ $t('Address') }}</strong>: c/ Peris y Valero, 166 – 46006 – Valencia, España.<br />
              <strong>{{ $t('Telefono') }}</strong>: <a href="tel:963744507" >963744507</a><br />
              <strong>{{ $t('Email') }}</strong>: <a href="mailto:info@servipyme.es" >info@servipyme.es</a><br />
              <strong>CIF</strong>: B40653081<br />
              <strong>{{ $t('avisoLegal.Text2_2') }}</strong>: {{ $t('avisoLegal.Text2_3') }}</p>
              <h2>{{ $t('avisoLegal.Title3') }}</h2>
              <p>{{ $t('avisoLegal.Text3_1') }}</p>
              <p>{{ $t('avisoLegal.Text3_2') }}</p>
              <p>{{ $t('avisoLegal.Text3_3') }}</p>
              <p>{{ $t('avisoLegal.Text3_4') }}</p>
              <p>{{ $t('avisoLegal.Text3_5') }}</p>
              <p>{{ $t('avisoLegal.Text3_6') }}</p>
              <h2>{{ $t('avisoLegal.Title4') }}</h2>
              <p>{{ $t('avisoLegal.Text4_1') }}</p>
              <p>{{ $t('avisoLegal.Text4_2') }}</p>
              <p>
              <ul>
                <li>{{ $t('avisoLegal.Text4_2_1') }}</li>
                <li>{{ $t('avisoLegal.Text4_2_2') }}</li>
                <li>{{ $t('avisoLegal.Text4_2_3') }}</li>
                <li>{{ $t('avisoLegal.Text4_2_4') }}</li>
                <li>{{ $t('avisoLegal.Text4_2_5') }}</li>
                <li>{{ $t('avisoLegal.Text4_2_6') }}</li>
                <li>{{ $t('avisoLegal.Text4_2_7') }}</li>
              </ul>
              </p>
              <p>{{ $t('avisoLegal.Text4_3') }}</p>
              <p>{{ $t('avisoLegal.Text4_4') }}</p>
              <p>{{ $t('avisoLegal.Text4_5') }}</p>
              <p>{{ $t('avisoLegal.Text4_6') }}</p>
              <p>{{ $t('avisoLegal.Text4_7') }}</p>
              <p>{{ $t('avisoLegal.Text4_8') }}</p>
              <p>{{ $t('avisoLegal.Text4_9') }}</p>
              <h2>{{ $t('avisoLegal.Title5') }}</h2>
              <p>{{ $t('avisoLegal.Text5_1') }}</p>
              <p>{{ $t('avisoLegal.Text5_2') }}</p>
              <p>{{ $t('avisoLegal.Text5_3') }}</p>
              <p>{{ $t('avisoLegal.Text5_4') }}</p>
              <p>{{ $t('avisoLegal.Text5_5') }}</p>
              <p>{{ $t('avisoLegal.Text5_6') }}</p>
              <h2>{{ $t('avisoLegal.Title6') }}</h2>
              <p>{{ $t('avisoLegal.Text6_1') }}</p>
              <p>{{ $t('avisoLegal.Text6_2') }}</p>
              <p>{{ $t('avisoLegal.Text6_3') }}</p>
              <p>{{ $t('avisoLegal.Text6_4') }}</p>
              <h2>{{ $t('avisoLegal.Title7') }}</h2>
              <p>{{ $t('avisoLegal.Text7_1') }}</p>
              <p>{{ $t('avisoLegal.Text7_2') }}</p>
              <p>{{ $t('avisoLegal.Text7_3') }}</p>
              <p>{{ $t('avisoLegal.Text7_4') }}</p>
              <p>{{ $t('avisoLegal.Text7_5') }}</p>
              <p>{{ $t('avisoLegal.Text7_6') }}</p>
              <h2>{{ $t('avisoLegal.Title8') }}</h2>
              <p>{{ $t('avisoLegal.Text8_1') }}</p>
              <p>{{ $t('avisoLegal.Text8_2') }}</p>
              <h2>{{ $t('avisoLegal.Title9') }}</h2>
              <p>{{ $t('avisoLegal.Text9_1') }}</p>
              <h2>{{ $t('avisoLegal.Title10') }}</h2>
              <p>{{ $t('avisoLegal.Text10_1') }}</p>
              <p>{{ $t('avisoLegal.Text10_2') }}</p>
              <p>{{ $t('avisoLegal.Text10_3') }}</p>
              <a href="/" class="link-back" >{{ $t('GoHome') }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col w-full self-end">
        <footer-public></footer-public>
      </div>
    </div>
  </div>

</template>

<script>
    import HeaderPublic from '../../components/Public/Header';
    import FooterPublic from '../../components/Public/Footer';

    export default {
        components: {
            HeaderPublic,
            FooterPublic
        },
        data () {
            return {
            }
        }

    }

</script>

<style></style>
